import logger from './logger';

/**
 * Initialize Web Shell Client Identity and Emit Nav Events
 * @param {Function} setIsLoggedIn
 * @param {Function} setUserProfile
 * @returns {void}
 */
export async function initializeWebShellIdentity(setIsLoggedIn, setUserProfile) {
  const { getIsLoggedIn, getUserProfile } = window.webShellClient.identity;
  try {
    const isLoggedIn = await getIsLoggedIn();
    setIsLoggedIn(isLoggedIn);
  } catch (error) {
    logger.error({ error, context: 'NikeDotcomNav:identityLogin' });
  }
  try {
    const userProfile = await getUserProfile();
    setUserProfile(userProfile);
  } catch (error) {
    logger.error({ error, context: 'NikeDotcomNav:identityProfile' });
  }
}
